/**
 * Advisor Support Modal JavaScript
 * Handles the self-reporting modal functionality including:
 * - File drag & drop
 * - Character count
 * - Pill toggle buttons
 * - Form validation
 * - AJAX submission
 * 
 * Design based on Signature Travel Network handoff mockup
 */
/* global HE */
(function advisorSupportModalModule($)
{
	'use strict';

	var AdvisorSupportModal = {
		maxFiles         : 10,
		maxFileSize      : 26214400,
		allowedExtensions: ['jpg', 'jpeg', 'png', 'gif', 'pdf', 'doc', 'docx', 'txt', 'eml', 'msg'],
		selectedFiles    : [],
		touched          : false,

		init: function init() {
			this.bindEvents();
		},

		bindEvents: function bindEvents() {
			var self = this;
			var $doc = $(document);

			// Drop any previously bound copy (web.min.js also includes this file)
			$doc.off('.advisorSupport');
			$doc.off('click', '.report-issue-btn, .report-issue-floating-tab');
			$doc.off('input', '#advisorsupportreport-issue_description');
			$doc.off('blur', '#advisorsupportreport-issue_description');
			$doc.off('click', '.pill-btn');
			$doc.off('dragover dragenter dragleave dragend drop', '#file-drop-zone');
			$doc.off('change', '#attachments');
			$doc.off('click', '.browse-link');
			$doc.off('click', '.file-remove');
			$doc.off('click', '#submit-support-request');
			$doc.off('hidden.bs.modal', '#advisor-support-modal');

			$doc.on('click.advisorSupport', '.report-issue-btn, .report-issue-floating-tab', function onReportIssueClick(e) {
				e.preventDefault();
				// Prefer attr over .data() so we always read the live DOM value
				self.openModal($(this).attr('data-reservation-id') || $(this).data('reservation-id'));
			});

			$doc.on('input.advisorSupport', '#advisorsupportreport-issue_description', function onDescriptionInput() {
				self.updateCharCount($(this));
				self.validateForm();
			});

			$doc.on('blur.advisorSupport', '#advisorsupportreport-issue_description', function onDescriptionBlur() {
				self.touched = true;
				self.validateDescription();
			});

			$doc.on('click.advisorSupport', '.pill-btn', function onPillBtnClick(e) {
				e.preventDefault();
				self.handlePillToggle($(this));
				self.validateForm();
			});

			$doc.on('dragover.advisorSupport dragenter.advisorSupport', '#file-drop-zone', function onDragOver(e) {
				e.preventDefault();
				e.stopPropagation();
				$(this).addClass('drag-over');
			});

			$doc.on('dragleave.advisorSupport dragend.advisorSupport drop.advisorSupport', '#file-drop-zone', function onDragLeave(e) {
				e.preventDefault();
				e.stopPropagation();
				$(this).removeClass('drag-over');
			});

			$doc.on('drop.advisorSupport', '#file-drop-zone', function onFileDrop(e) {
				var files;

				e.preventDefault();
				files = e.originalEvent.dataTransfer.files;
				self.handleFileSelect(files);
			});

			$doc.on('change.advisorSupport', '#attachments', function onAttachmentsChange() {
				self.handleFileSelect(this.files);
			});

			$doc.on('click.advisorSupport', '.browse-link', function onBrowseLinkClick(e) {
				e.preventDefault();
				$('#attachments').trigger('click');
			});

			$doc.on('click.advisorSupport', '.file-remove', function onRemoveFileClick(e) {
				var index = $(this).data('index');

				e.stopPropagation();
				self.removeFile(index);
			});

			$doc.on('click.advisorSupport', '#submit-support-request', function onSubmitClick(e) {
				e.preventDefault();
				self.touched = true;
				self.submitForm();
			});

			$doc.on('hidden.bs.modal.advisorSupport', '#advisor-support-modal', function onModalHidden() {
				self.resetModal();
			});
		},

		openModal: function openModal(reservationId) {
			var self = this;
			var url = '/Support/reportModal';
			var $modal;
			var modal;

			// Prefer path param — Hardcore often drops query-string keys from requestData['get']
			if (reservationId) {
				url += '/' + encodeURIComponent(reservationId);
			}

			$modal = $('#advisor-support-modal');
			if ($modal.length === 0) {
				$modal = $(
					'<div class="modal fade" id="advisor-support-modal" tabindex="-1" aria-labelledby="advisorSupportModalLabel" aria-hidden="true">'
					+ '<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">'
					+ '<div class="modal-content"></div>'
					+ '</div></div>'
				);
				$('body').append($modal);
			}

			$modal.find('.modal-content').html(
				'<div class="modal-body text-center py-5">'
				+ '<div class="spinner-border text-primary" role="status">'
				+ '<span class="visually-hidden">Loading...</span>'
				+ '</div></div>'
			);

			modal = new bootstrap.Modal($modal[0]);
			modal.show();

			HE.Ajax.get(url)
				.then(function onOpenSuccess(response) {
					$modal.find('.modal-content').html(response);
					self.initializeForm();
				})
				.fail(function onOpenError() {
					$modal.find('.modal-content').html(
						'<div class="modal-body text-center py-5">'
						+ '<p class="text-danger">Unable to load the support form. Please try again.</p>'
						+ '<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>'
						+ '</div>'
					);
				});
		},

		initializeForm: function initializeForm() {
			this.selectedFiles = [];
			this.touched = false;
			this.validateForm();
		},

		updateCharCount: function updateCharCount($textarea) {
			var count = $textarea.val().length;

			$('#char-count-value').text(count);
		},

		validateDescription: function validateDescription() {
			var $textarea = $('#advisorsupportreport-issue_description');
			var $validation = $('#description-validation');
			var value = $textarea.val().trim();

			if (this.touched && value.length === 0) {
				$textarea.addClass('is-invalid');
				$validation.text('Please add at least a short description.');
			} else {
				$textarea.removeClass('is-invalid');
				$validation.text('');
			}
		},

		handlePillToggle: function handlePillToggle($button) {
			var field = $button.data('field');
			var value = $button.data('value');
			var $group = $button.closest('.pill-group');
			var $hiddenField = $('#' + field);

			$hiddenField.val(value);

			$group.find('.pill-btn').removeClass('active').attr('aria-checked', 'false');
			$button.addClass('active').attr('aria-checked', 'true');

			$('#' + field + '-validation').addClass('d-none');
		},

		handleFileSelect: function handleFileSelect(files) {
			var self = this;
			var ext;

			$.each(files, function eachFile(i, file) {
				if (self.selectedFiles.length >= self.maxFiles) {
					self.showError('Maximum of ' + self.maxFiles + ' files allowed.');
					return false;
				}

				if (file.size > self.maxFileSize) {
					self.showError('File "' + file.name + '" exceeds the 25MB size limit.');
					return true;
				}

				ext = file.name.split('.').pop().toLowerCase();
				if (self.allowedExtensions.indexOf(ext) === -1) {
					self.showError('File type "' + ext + '" is not allowed.');
					return true;
				}

				self.selectedFiles.push(file);
			});

			self.updateFileList();
			self.updateFileInput();
			self.updateFileCount();
		},

		removeFile: function removeFile(index) {
			this.selectedFiles.splice(index, 1);
			this.updateFileList();
			this.updateFileInput();
			this.updateFileCount();
		},

		updateFileList: function updateFileList() {
			var self = this;
			var $fileList = $('#file-list');
			var $dropZone = $('#file-drop-zone');

			$fileList.empty();

			if (this.selectedFiles.length === 0) {
				$dropZone.removeClass('has-files');
				return;
			}

			$dropZone.addClass('has-files');

			$.each(this.selectedFiles, function eachSelectedFile(i, file) {
				var size = self.formatFileSize(file.size);
				var isImage = file.type && file.type.startsWith('image/');
				var iconClass = isImage ? 'file-icon is-image' : 'file-icon';
				var iconSvg = isImage
					? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="1.5"/><path d="m21 16-5-5-9 9"/></svg>'
					: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/></svg>';

				var $chip = $(
					'<div class="file-chip">'
					+ '<div class="' + iconClass + '">' + iconSvg + '</div>'
					+ '<div class="file-info">'
					+ '<span class="file-name">' + self.escapeHtml(file.name) + '</span>'
					+ '<span class="file-size">' + size + '</span>'
					+ '</div>'
					+ '<button type="button" class="file-remove" data-index="' + i + '" aria-label="Remove ' + self.escapeHtml(file.name) + '">'
					+ '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2M6 6l1 14a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-14"/></svg>'
					+ '</button>'
					+ '</div>'
				);

				$fileList.append($chip);
			});
		},

		updateFileCount: function updateFileCount() {
			var $countDisplay = $('#file-count-display');
			var $countValue = $('#file-count-value');

			if (this.selectedFiles.length > 0) {
				$countValue.text(this.selectedFiles.length);
				$countDisplay.removeClass('d-none');
			} else {
				$countDisplay.addClass('d-none');
			}
		},

		updateFileInput: function updateFileInput() {
			var dt = new DataTransfer();
			var $input;

			$.each(this.selectedFiles, function eachFileForTransfer(i, file) {
				dt.items.add(file);
			});

			$input = $('#attachments')[0];
			$input.files = dt.files;
		},

		formatFileSize: function formatFileSize(bytes) {
			var k;
			var sizes;
			var i;

			if (bytes === 0) {
				return '0 Bytes';
			}

			k = 1024;
			sizes = ['Bytes', 'KB', 'MB', 'GB'];
			i = Math.floor(Math.log(bytes) / Math.log(k));

			return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
		},

		escapeHtml: function escapeHtml(text) {
			var div = document.createElement('div');

			div.textContent = text;
			return div.innerHTML;
		},

		validateForm: function validateForm() {
			var isValid = true;
			var description;
			var requiredPills = [
				'how_often',
				'reported_before',
				'is_preventing_proceeding',
				'append_to_existing_pnr'
			];

			description = $('#advisorsupportreport-issue_description').val();
			if (!description || description.trim().length === 0) {
				isValid = false;
			}

			$.each(requiredPills, function eachRequiredPill(i, field) {
				var value = $('#' + field).val();

				if (!value || String(value).trim().length === 0) {
					isValid = false;
				}
			});

			$('#submit-support-request').prop('disabled', !isValid);

			return isValid;
		},

		showError: function showError(message) {
			$('#form-error-message').text(message).removeClass('d-none');
		},

		submitForm: function submitForm() {
			var self = this;
			var $form = $('.advisor-support-form');
			var $submitBtn = $('#submit-support-request');
			var formData;
			var actionUrl;

			self.validateDescription();

			$.each([
				'how_often',
				'reported_before',
				'is_preventing_proceeding',
				'append_to_existing_pnr'
			], function eachRequiredPill(i, field) {
				if (!$('#' + field).val()) {
					$('#' + field + '-validation').removeClass('d-none');
				}
			});

			if (!self.validateForm()) {
				return;
			}

			$submitBtn.prop('disabled', true).addClass('is-submitting');

			formData = new FormData($form[0]);
			actionUrl = HE.get_url($form.attr('action'));

			$.ajax({
				url        : actionUrl,
				method     : 'POST',
				data       : formData,
				processData: false,
				contentType: false,
				dataType   : 'json',
				success    : function onSubmitSuccess(response) {
					if (response && response.status === 'success') {
						self.showSuccessState(response.data);
					} else if (response && response.status === 'validation_error') {
						self.handleValidationErrors(response.data);
						$submitBtn.prop('disabled', false).removeClass('is-submitting');
					} else {
						self.showError((response && response.data) || 'An error occurred. Please try again.');
						$submitBtn.prop('disabled', false).removeClass('is-submitting');
					}
				},
				error: function onSubmitError(xhr) {
					var message = 'Unable to submit the form. Please try again.';
					if (xhr && xhr.responseJSON && xhr.responseJSON.data) {
						message = xhr.responseJSON.data;
					}
					self.showError(message);
					$submitBtn.prop('disabled', false).removeClass('is-submitting');
				}
			});
		},

		handleValidationErrors: function handleValidationErrors(errors) {
			var self = this;

			$('.advisor-support-form .is-invalid').removeClass('is-invalid');

			if (Array.isArray(errors)) {
				$.each(errors, function eachError(i, error) {
					if (error.attributes && error.attributes.id) {
						$('#' + error.attributes.id).addClass('is-invalid');
					}
					if (error.errors && error.errors.length > 0) {
						self.showError(error.errors.join(' '));
					}
				});
			} else if (typeof errors === 'string') {
				self.showError(errors);
			}
		},

		showSuccessState: function showSuccessState(data) {
			var ticketId;

			$('.signature-modal-header, .signature-modal-body, .signature-modal-footer').addClass('d-none');
			$('#support-success-state').removeClass('d-none');

			if (data && data.booking_reference) {
				ticketId = data.booking_reference;
			} else if (data && data.report_id) {
				ticketId = 'SR-' + data.report_id;
			}

			if (ticketId) {
				$('#success-ticket-id').text(ticketId);
			}
		},

		resetModal: function resetModal() {
			this.selectedFiles = [];
			this.touched = false;
			$('.signature-modal-header, .signature-modal-body, .signature-modal-footer').removeClass('d-none');
			$('#support-success-state').addClass('d-none');
			$('#form-error-message').addClass('d-none');
		}
	};

	$(document).ready(function onDocumentReady() {
		AdvisorSupportModal.init();
	});

	window.AdvisorSupportModal = AdvisorSupportModal;

}(jQuery));
